import React, { useEffect } from "react";
import { Flex, Text } from "@radix-ui/themes";
import { Button } from "../../../ui/Button";
import _ from "lodash";
import { TbPlus } from "react-icons/tb";
import { useTranslation } from "react-i18next";
import { NavLink, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import RoleRequire from "../../../helpers/auth/RoleRequire";
import { useAppStore } from "../../../stores/RootStore";
import { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "../../../ui/DataTable/DataTable";
import { ProducersTableData } from "../../../types/formDataTypes";
import { Separator } from "../../../ui/Separator";
import { Input } from "../../../ui/Input/Input";
import { useRefreshProducers } from "../../../hooks/useRefreshStateHooks/useRefreshProducers";
import { MenuDataTable } from "../../../ui/DataTable/MenuDataTable";
import { Header } from "../../../components/Header";

export const Producers = () => {
  let {id} = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [search, setSearch] = React.useState("");
  const currentSite = useAppStore().currentSite
  const producers = useAppStore((state) => state.producers);

  // Получение данных и обновление их в сторе.
  const updateItems = useRefreshProducers();
  useEffect(() => {
    updateItems();
  }, []);

  let nodes = producers?.map((producer) => {
    return {
      id: producer.id,
      name: producer.attributes.name,
      equipment_type_names: producer.attributes.equipment_type_names,
      country: producer.attributes.country,
      models_count: producer.attributes.models_count,
    };
  });

  // Сортировка по умолчанию
  nodes = _.sortBy(nodes, []);
  let data = { nodes };

  const handleSearch = (event: any) => {
    setSearch(event.target.value);
  };

  // Фильтрация через поиск
  data = {
    nodes: data.nodes?.filter((item) => item.name.toLowerCase().includes(search.toLowerCase())),
  };

  const columns: ColumnDef<ProducersTableData>[] = [
    {
      accessorKey: "name",
      header: t("title_name"),
      size: 1000,
      cell: ({ row }) => row.getValue("name"),
    },
    {
      accessorKey: "country",
      header: t("country"),
      size: 150,
      cell: ({ row }) => row.getValue("country"),
    },
    {
      accessorKey: "models_count",
      header: t("models_count"),
      size: 100,
      cell: ({ row }) => row.getValue("models_count"),
    },
    {
      id: "equipment_types",
      accessorFn: (row) => _.join(row.equipment_type_names, ", "),
      header: t("equipment_types"),
      size: 200,
      cell: ({ row }) => <div style={{ wordBreak: "break-word" }}>{row.getValue("equipment_types")}</div>,
    },
  ];



  return (
    <div className="flex flex-col w-full h-full">
      <div className="flex-none flex w-full h-14 px-6 justify-between items-center">
        <div className="flex text-base items-center gap-1">
          <NavLink to={"/"}>
            <span className="font-medium">{currentSite?.name ? currentSite?.name : "..."}</span> 
          </NavLink>
          <span>/</span>
          <NavLink to={"/data/directories"}>
            <span className="font-medium">{t("directories")}</span>
          </NavLink> 
          <span>/</span>
          {location.pathname == "/data/manufactures/" || location.pathname == "/data/manufactures" ? <span>{t("manufactures")}</span> : <NavLink to={"/data/manufactures"}><span>{t("manufactures")}</span></NavLink>}
          {(id || location.pathname == "/data/manufactures/new") && <span>/</span>}
          {id && <span>{data.nodes.find(n => n.id == id)?.name}</span>}
          {location.pathname == "/data/manufactures/new" && <span>{t('adding_manufacture')}</span>}
        </div>
      </div>
      <Separator className="flex-none"/>
      {id || location.pathname == "/data/manufactures/new" ? <Outlet /> :
        <div className="flex flex-col w-full h-full mx-auto overflow-hidden">
          <Header name={t('manufactures')} backName={t("directories")} backLink={"/data/directories"} />
          <div className="flex-none flex flex-row w-full h-10 items-center gap-4 justify-between px-6">
            <Input 
              className="h-8"
              placeholder={t("search")}
              onChange={handleSearch}
              value={search}
              autoComplete="off"
              width="100%" 
            />
            <RoleRequire role="maintainer">
              <Button variant={"default"} size={"md"} onClick={() => navigate("new")}>{t("add_manufacture")}</Button>
            </RoleRequire>
          </div>
          <MenuDataTable route="/data/manufactures" data={data.nodes} columns={columns} onClickRow={navigate} />
        </div>
      }
    </div>
  )
};